import { Button, Modal, Typography } from '@uikit';
import { redirect } from '@utils';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomTranslation } from '../CustomTranslation';

const ErrorBoundaryFallback = () => {
  const modalRef = useRef<ModalHTMLElement>(null);

  const { t } = useTranslation('');

  useEffect(() => {
    if (!modalRef?.current) return;
    modalRef.current.openModal();
  }, [modalRef]);

  return (
    <Modal
      ref={modalRef}
      title={
        <Typography variant="h3" className="mb-0">
          {t('systemNotAvailableModal.title')}
        </Typography>
      }
      content={
        <Typography className="mb-0">
          <CustomTranslation text={t('systemNotAvailableModal.content')} />
        </Typography>
      }
      footer={
        <Button onClick={redirect.redirectToIBB}>
          {t('systemNotAvailableModal.action')}
        </Button>
      }
    />
  );
};

export default ErrorBoundaryFallback;
